export function getSubnetId(subnetId: string) {
  return subnetId
    .trim()
    .split(',')
    .map((id) => id.trim())
    .filter((id) => !!id);
}

export function isCPDisabled(status: string) {
  return !['active', 'upgradecomplete', 'upgrading'].includes(status);
}
